module.exports = __webpack_public_path__ + "img/search_loading.596eaf8a.gif";